import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { MdPhoneAndroid } from "react-icons/md";
import Layout from "../components/Layout";

const fields = [
  { key: "deviceName",              label: "Device Name" },
  { key: "deviceType",              label: "Device Type" },
  { key: "deviceModelNumber",       label: "Model Number" },
  { key: "deviceIMEI",              label: "IMEI" },
  { key: "previousDeviceIMEI",      label: "Previous IMEI" },
  { key: "deviceIMEIChanged",       label: "IMEI Changed" },
  { key: "operatingSystemName",     label: "OS Name" },
  { key: "operatingSystemProvider", label: "OS Provider" },
  { key: "operatingSystemVersion",  label: "OS Version" },
  { key: "otaSupport",              label: "OTA Support" },
  { key: "deviceFrequencies",       label: "Frequencies" },
  { key: "deviceAttributes",        label: "Attributes" },
];

const displayValue = (val) => {
  if (val === null || val === undefined || val === "") return "N/A";
  if (typeof val === "boolean") return val ? "Yes" : "No";
  return String(val);
};

const isNA = (val) => val === null || val === undefined || val === "";

const DataInfoResultPage = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const data = state || {};

  return (
    <Layout title="Device Info">
      <div className="max-w-2xl">
        {/* Device header card */}
        <div
          className="rounded-2xl p-6 mb-6 flex items-center gap-4"
          style={{ backgroundColor: "#1c1c1c", border: "1px solid #2a2a2a" }}
        >
          <div
            className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0"
            style={{ backgroundColor: "#ffc20e22" }}
          >
            <MdPhoneAndroid className="text-2xl" style={{ color: "#ffc20e" }} />
          </div>
          <div>
            <p className="text-xs font-semibold uppercase tracking-wider mb-0.5" style={{ color: "#888888" }}>Device</p>
            <h2 className="text-lg font-bold" style={{ color: "#ffffff" }}>
              {isNA(data.deviceName) ? "Unknown Device" : data.deviceName}
            </h2>
            {!isNA(data.deviceType) && (
              <span className="text-xs font-medium" style={{ color: "#ffc20e" }}>{data.deviceType}</span>
            )}
          </div>
        </div>

        {/* Fields grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {fields.map(({ key, label }) => (
            <div
              key={key}
              className="rounded-xl px-5 py-4"
              style={{ backgroundColor: "#1c1c1c", border: "1px solid #2a2a2a" }}
            >
              <p className="text-xs font-semibold uppercase tracking-wider mb-1" style={{ color: "#666666" }}>{label}</p>
              <p
                className="text-sm font-medium break-all"
                style={{ color: isNA(data[key]) ? "#444444" : "#ffffff", fontStyle: isNA(data[key]) ? "italic" : "normal" }}
              >
                {displayValue(data[key])}
              </p>
            </div>
          ))}
        </div>

        <button
          onClick={() => navigate("/device-info")}
          className="mt-6 px-6 py-2.5 rounded-xl text-sm font-medium transition-colors"
          style={{ border: "1px solid #2a2a2a", color: "#aaaaaa" }}
          onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "#2a2a2a"; }}
          onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "transparent"; }}
        >
          ← Back
        </button>
      </div>
    </Layout>
  );
};

export default DataInfoResultPage;
